<template>
  <div class="refund-list">
    <div class="filter-form">
      <el-form :model="filterForm" label-suffix="：">
        <el-form-item label="退款类型">
          <el-select v-model="filterForm.refundType" @change="getList">
            <el-option label="全部" value="" />
            <el-option
              v-for="item in refundTypeOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <span v-if="isShowTip" class="text-danger m-l-20">
            保证金额度因参与项目占用{{
              guaranteePreSave.consumeTotalAmount
            }}元，导致部分入账记录的余额暂时不支持全额退款，请等项目结束额度解除占用后再退款。
          </span>
        </el-form-item>
      </el-form>
      <el-button v-if="showRefundAll" type="text" @click="openRefundAllAction">
        全部退款
      </el-button>
    </div>
    <jczh-table-content
      :data="list"
      :option="listOption"
      pagination
      :total="total"
      :page.sync="page"
      :limit.sync="size"
      border
      table-id=""
      @pagination="getList"
    >
      <template v-slot:action="{ row }">
        <el-button
          v-if="showRefund(row)"
          type="text"
          @click="openRefundAction(row)"
        >
          退款
        </el-button>
        <el-button
          v-if="showRefundDetail(row)"
          type="text"
          @click="openRefundDetail(row)"
        >
          退款明细
        </el-button>
      </template>
    </jczh-table-content>

    <guarantee-pre-save-refund-all-dialog
      ref="refundAllDialog"
      @refundAll="getList"
    />
    <guarantee-pre-save-refund-dialog ref="refundDialog" @refund="getList" />
    <guarantee-pre-save-refund-detail-dialog ref="refundDetailDialog" />
  </div>
</template>

<script>
import GuaranteePreSaveRefundAllDialog from '@/components/guarantee/guarantee-pre-save/GuaranteePreSaveRefundAllDialog.vue'
import GuaranteePreSaveRefundDialog from '@/components/guarantee/guarantee-pre-save/GuaranteePreSaveRefundDialog.vue'
import GuaranteePreSaveRefundDetailDialog from '@/components/guarantee/guarantee-pre-save/GuaranteePreSaveRefundDetailDialog.vue'
import {
  guaranteePreSaveReceiptTypeDict,
  guaranteePreSaveRefundTypeDict
} from '@/dictionary/financial'
import { mapState } from 'vuex'
/**
 * 保证金预存退款记录
 */
export default {
  name: 'GuaranteePreSaveRefund',

  components: {
    GuaranteePreSaveRefundAllDialog,
    GuaranteePreSaveRefundDialog,
    GuaranteePreSaveRefundDetailDialog
  },

  data() {
    return {
      filterForm: {
        // 退款类型
        refundType: ''
      },

      list: [],
      listOption: [
        {
          label: '类型',
          prop: 'accountType',
          filter: value =>
            guaranteePreSaveReceiptTypeDict.translate(value)?.label
        },
        { label: '入账金额（元）', prop: 'paidAmount' },
        { label: '余额', prop: 'useAmount' },
        { label: '占用金额', prop: 'consumeAmount' },
        { label: '可退款金额', prop: 'remainAmount' },
        { label: '打款账号', prop: 'draweeAccNo' },
        { label: '户名', prop: 'draweeAccName' },
        { label: '入账时间', prop: 'entryDate' },
        {
          label: '退款类型',
          prop: 'refundStatus',
          filter: value =>
            guaranteePreSaveRefundTypeDict.translate(value)?.label
        },
        { label: '操作', slotName: 'action' }
      ],
      page: 1,
      size: 10,
      total: 0
    }
  },

  computed: {
    ...mapState('finance', ['guaranteePreSave']),

    refundTypeOption() {
      return guaranteePreSaveRefundTypeDict.array
    },

    showRefundAll() {
      // 当占用中额度为0，且账户总额度大于0时，显示
      return (
        Number(this.guaranteePreSave.useTotalAmount) > 0 &&
        Number(this.guaranteePreSave.consumeTotalAmount === 0)
      )
    },

    isShowTip() {
      return Number(this.guaranteePreSave?.consumeTotalAmount || 0) > 0
    }
  },

  created() {
    this.getList()
  },

  methods: {
    getList() {
      const params = {
        pageNum: this.page,
        pageSize: this.size,
        receiptType: guaranteePreSaveReceiptTypeDict.REFUND.value,
        refundType: this.filterForm.refundType
      }
      this.$store
        .dispatch('finance/getGuaranteePreSaveRecord', params)
        .then(data => {
          this.list = data?.records || []
          this.total = data?.total || 0
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    showRefund(row) {
      return Number(row.remainAmount) > 0
    },

    openRefundAction(row) {
      this.$refs.refundDialog.openDialog(row)
    },

    showRefundDetail(row) {
      return row.refundStatus !== guaranteePreSaveRefundTypeDict.NO_REFUND.value
    },

    openRefundDetail(row) {
      this.$refs.refundDetailDialog.openDialog(row)
    },

    openRefundAllAction() {
      const occupyNum = Number(this.guaranteePreSave.consumeTotalAmount)
      const canRefundAll = occupyNum === 0
      this.$refs.refundAllDialog.openDialog(canRefundAll)
    }
  }
}
</script>

<style scoped lang="scss">
.filter-form {
  padding: 20px 20px 6px 20px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  ::v-deep .el-form {
    width: 80%;
  }
}
</style>
